import React from 'react';
import { Card, Avatar, Tag } from 'antd';
import {
    MailOutlined,
    PhoneOutlined,
    CalendarOutlined,
    UserOutlined,
    HomeOutlined,
    TeamOutlined
} from '@ant-design/icons';
import { cn } from '../../../../utils/cn';
import { getInitials } from '../../../../utils/helper';

const EnhancedLeadsImportedUserCardView = ({
    record,
    onCardClick,
    onToggleHotLead
}) => {
    const initials = getInitials(record.name);
    return (
        <Card
            hoverable
            className="h-full relative"
            onClick={() => onCardClick && onCardClick(record)}

        >
            <div className="space-y-3 sm:space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-2 sm:space-x-3 overflow-hidden">
                        <Avatar
                            size={40}
                            className={cn("flex-shrink-0 font-semibold text-base sm:text-lg sm:w-12 sm:h-12", record.originalData?.photo ? "" : "!bg-primary")}
                            src={record.originalData?.photo ?? ""}
                        >
                            {initials}
                        </Avatar>
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-sm sm:text-base mb-1 truncate" title={record.name}>
                                {record.name || "N/A"}
                            </h3>
                            {record.userEmail && (
                                <p className="text-gray-500 text-xs sm:text-sm mb-0 truncate" title={record.userEmail}>
                                    Client: {record.userEmail}
                                </p>
                            )}
                        </div>
                    </div>
                    {onToggleHotLead && (
                        <div onClick={(e) => e.stopPropagation()} className="ml-2 flex-shrink-0">
                            {record.isHotLead ? (
                                <Tag
                                    color="success"
                                    className="cursor-pointer m-0 flex items-center gap-1"
                                    onClick={() => onToggleHotLead(record)}
                                >
                                    <UserOutlined /> Hot Lead
                                </Tag>
                            ) : (
                                <span
                                    onClick={() => onToggleHotLead(record)}
                                    className="!text-primary hover:!text-primary/80 transition-colors text-[10px] sm:text-xs flex items-center gap-1 cursor-pointer whitespace-nowrap"
                                >
                                    <UserOutlined /> Mark as Hot Lead
                                </span>
                            )}
                        </div>
                    )}
                </div>

                {/* Contact Info */}
                <div className="space-y-1.5 sm:space-y-2 border-b border-gray-200 pb-2 sm:pb-3">
                    <div className="flex items-center text-xs sm:text-sm text-gray-600">
                        <MailOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.email ?? "user-email"}>{record.email ?? "-"}</span>
                    </div>
                    <div className="flex items-center text-xs sm:text-sm text-gray-600">
                        <PhoneOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.phone ?? "user-phone"}>{record.phone ?? "-"}</span>
                    </div>
                    <div className="flex items-center text-xs sm:text-sm text-gray-600">
                        <HomeOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.address ?? "user-address"}>{record.address ?? "-"}</span>
                    </div>
                </div>

                {/* Event Details Section */}
                <div className="space-y-2 sm:space-y-3">
                    {/* Lead Source */}
                    <div className="flex items-center justify-between">
                        <span className="text-xs sm:text-sm text-gray-600 font-medium">
                            Lead Source:
                        </span>
                        <Tag color="blue" className="capitalize">
                            {record.leadSource}
                        </Tag>
                    </div>

                    {/* Event Name */}
                    <div className="flex items-center justify-between">
                        <span className="text-xs sm:text-sm text-gray-600 font-medium">
                            Event:
                        </span>
                        <span className="text-xs sm:text-sm text-gray-700 truncate max-w-[60%]" title={record.eventName}>
                            {record.eventName ?? "-"}
                        </span>
                    </div>

                    {/* Event Type */}
                    <div className="flex items-center justify-between">
                        <span className="text-xs sm:text-sm text-gray-600 font-medium">
                            Event Type:
                        </span>
                        <span className="text-xs sm:text-sm text-gray-700">
                            {record.eventType ?? "-"}
                        </span>
                    </div>

                    {/* Event Date */}
                    <div className="flex items-center justify-between">
                        <span className="text-xs sm:text-sm text-gray-600 font-medium">
                            Event Date:
                        </span>
                        <span className="text-xs sm:text-sm text-gray-700">
                            {record.eventDate ?? "-"}
                        </span>
                    </div>

                    {/* Guest Count */}
                    <div className="flex items-center justify-between">
                        <span className="text-xs sm:text-sm text-gray-600 font-medium">
                            <TeamOutlined className="mr-1" />
                            Guest Count:
                        </span>
                        <span className="text-xs sm:text-sm text-gray-700">
                            {record.guestCount ?? "-"}
                        </span>
                    </div>


                    {/* Imported At */}
                    <div className="flex items-center justify-between border-t border-gray-200 pt-2 sm:pt-3">
                        <span className="text-xs sm:text-sm text-gray-600 font-medium">
                            <CalendarOutlined className="mr-1" />
                            Imported At:
                        </span>
                        <span className="text-xs sm:text-sm text-gray-700">
                            {record.importedAt}
                        </span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedLeadsImportedUserCardView;
